module.exports = __webpack_public_path__ + "img/fiveday1-3.bb5bd5d4.jpg";